import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import JavascriptTimeAgo from 'javascript-time-ago';

import en from 'javascript-time-ago/locale/en';
import hu from 'javascript-time-ago/locale/hu';
import de from 'javascript-time-ago/locale/de';

JavascriptTimeAgo.addLocale(en);
JavascriptTimeAgo.addLocale(hu);
JavascriptTimeAgo.addLocale(de);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
